import { ChannelSettingsReducerCreator } from '../types';

const clearInstanceToCreateReducer = (create: ChannelSettingsReducerCreator) => {
  return create.reducer((state) => {
    state.instanceToCreate = null;
  });
};

export default clearInstanceToCreateReducer;
